import ReactiveWidget from "lib/reactiveWidget";

import $              from "jquery"
import select2        from "select2"
import { createNewTag } from "lib/select2NewTag"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"

import GeocompletedAddress, { syncCustomAddressFields } from 'widgets/geocompletedAddress'

class ProposalBuilderWidget extends ReactiveWidget  {
  bind() {
    // Client
    this.clientNameSelect    = $(this.root.find('#proposal_form_client_name'))
    this.clientCompanySelect = $(this.root.find('#proposal_form_client_company_name'))
    this.clientEmail         = $(this.root.find('#proposal_form_client_email'))
    this.clientPhoneNumber   = $(this.root.find('#proposal_form_client_phone_number'))

    bindClientNameSelect.call(this)
    bindClientCompanySelect.call(this)

    // Applicant
    this.contactNameSelect    = $(this.root.find('#proposal_form_contact_name'))
    this.contactEmail         = $(this.root.find('#proposal_form_contact_email'))
    this.contactPhoneNumber   = $(this.root.find('#proposal_form_phone_number'))

    bindContactNameSelect.call(this)
    bindCcFields.call(this)

    bindAddressLocator.call(this);
    bindInspectionsSelect.call(this);

    bindCustomWorkDescriptions.call(this);
    toggleAdditionalWorksDescription.call(this, this.root.find('.works-description').val());

    bindFileUploadLabels(this.root);

    // not ideal as we might have multiple cocoons.
    this.root.on('cocoon:after-insert', (e, insertedItem) => {
      bindFileUploadLabels($(insertedItem));
      this.emit('item-loaded')
    });
  }

  render() {
  }
}

const bindCcFields = function() {
  // $("input[type=radio][name='proposal_form[proposal_type]']").click()
  $("input[type=radio][name='proposal_form[proposal_type]']").change(event => {
    const value = $(event.target).val()
    const ccFields = $('#cc-fields')

    if (['cc_pca_oc', 'cc'].includes(value)) {
      ccFields.removeClass('d-none')
      return
    }

    ccFields.addClass('d-none')
  })
}

const enableDisableClientFields = function() {
  // If greater than zero, must be an existing record
  if (this.clientNameSelect.val() > 0) {
    this.clientCompanySelect.attr('readonly', true)
    this.clientEmail.prop('readonly', true)
    this.clientPhoneNumber.prop('readonly', true)
  } else {
    this.clientCompanySelect.attr('readonly', false)
    this.clientEmail.prop('readonly', false)
    this.clientPhoneNumber.prop('readonly', false)
  }
}

const enableDisableContactFields = function() {
  // If greater than zero, must be an existing record
  if (this.contactNameSelect.val() > 0) {
    this.contactEmail.prop('readonly', true)
    this.contactPhoneNumber.prop('readonly', true)
  } else {
    this.contactEmail.prop('readonly', false)
    this.contactPhoneNumber.prop('readonly', false)
  }
}

const bindCustomWorkDescriptions = function() {
  this.root.find('.works-description').on('change', (e) => {
    toggleAdditionalWorksDescription.call(this, e.currentTarget.value)
  })
}

const toggleAdditionalWorksDescription = function(value) {
  if (value == 'custom') {
    this.root.find('.additional-works-description').removeClass('d-none')
    this.root.find('.additional-works-description input').prop('disabled', false)
  } else {
    this.root.find('.additional-works-description').addClass('d-none')
    this.root.find('.additional-works-description input').prop('disabled', true)
  }
}

const bindInspectionsSelect = function() {
  this.root.find('.inspection-checkbox').on('change', (e) => {
    updateInspectionCount.call(this)
  })

  this.root.find('.inspection-checkbox.additional_allowance').on('change', (e) => {
    toggleAllowanceComment.call(this)
  })

  updateInspectionCount.call(this)
  toggleAllowanceComment.call(this)
}

const toggleAllowanceComment = function() {
  let checked = this.root.find('.inspection-checkbox.additional_allowance').prop('checked')
  this.root.find('.additional_allowance_comment').prop('disabled', !checked)
}

const updateInspectionCount = function() {
  let selectedCount = this.root.find('.inspection-checkbox:checked').length
  this.root.find('.inspections-count').html(`(${selectedCount})`)
}

const bindAddressLocator = function() {
  const elem1 = this.root.find('#contact-address-fields-group')
  const elem2 = this.root.find('#address-fields-group')

  const elems = [elem1, elem2]

  elems.forEach(elem => {
    new GeocompletedAddress({
      root: elem,
      options: {
        types: ['address'],
        country: 'AU'
      }
    });

    syncCustomAddressFields(elem)
  })

};

var bindContactNameSelect = function() {
  this.contactNameSelect.select2({
    placeholder: 'Search or Add New Contact',
    minimumInputLength: 1,
    allowClear: true,
    tags: true,
    createTag: createNewTag,
    ajax: {
      url: '/select_data/users',
      dataType: 'json',
      delay: 250,
      data: (params) => {
        return {
          by_keyword: params.term,
          role: 'applicant'
        }
      },
      processResults: (data, page) => {
        return {
          results: data.collection,
          pagination: data.pagination
        }
      },
      cache: true
    }});

  this.contactNameSelect.on('select2:select', (e) => {
    let user = _.get(e.params, 'data', {})

    this.contactEmail.val(_.get(user, 'email', ""))
    this.contactPhoneNumber.val(_.get(user, 'phone_number', ""))

    enableDisableContactFields.call(this)

    // let account = _.get(user, 'accounts', [])[0]
    // if (account != undefined) {
    //   this.contactCompanySelect.select2("trigger", "select", {
    //     data: account
    //   });
    // }
  });

  this.contactNameSelect.on('select2:unselect', (e) => {
    this.contactEmail.val('')
    this.contactPhoneNumber.val('')
    enableDisableContactFields.call(this)
  });
}

var bindClientNameSelect = function() {
  this.clientNameSelect.select2({
    placeholder: 'Search or Add New Client',
    minimumInputLength: 1,
    allowClear: true,
    tags: true,
    createTag: createNewTag,
    ajax: {
      url: '/select_data/users',
      dataType: 'json',
      delay: 250,
      data: (params) => {
        return {
          by_keyword: params.term,
          role: 'client'
        }
      },
      processResults: (data, page) => {
        return {
          results: data.collection,
          pagination: data.pagination
        }
      },
      cache: true
    }});

  this.clientNameSelect.on('select2:select', (e) => {
    let user = _.get(e.params, 'data', {})

    this.clientEmail.val(_.get(user, 'email', ""))
    this.clientPhoneNumber.val(_.get(user, 'phone_number', ""))

    let account = _.get(user, 'accounts', [])[0]
    if (account != undefined) {
      this.clientCompanySelect.select2("trigger", "select", {
        data: account
      });
    }

    enableDisableClientFields.call(this)
  });

  this.clientNameSelect.on('select2:unselect', (e) => {
    this.clientCompanySelect.val('').trigger('change')
    this.clientEmail.val('')
    this.clientPhoneNumber.val('')
    enableDisableClientFields.call(this)
  });
}

var bindClientCompanySelect = function() {
  this.clientCompanySelect.select2({
    placeholder: '',
    minimumInputLength: 1,
    allowClear: true,
    tags: true,
    createTag: createNewTag,
    ajax: {
      url: '/select_data/accounts',
      dataType: 'json',
      delay: 250,
      data: (params) => {
        return { by_keyword: params.term }
      },
      processResults: (data, page) => {
        return {
          results: data.collection,
          pagination: data.pagination
        }
      },
      cache: true,
    }});
}

const bindFileUploadLabels = function(scope) {
  $(scope).find('.file-upload-label input[type="file"]').on('change', function() {
    const label = $(this).closest('.file-upload-label');
    const filename = this.files && this.files[0] ? this.files[0].name : null;
    let display = label.find('.file-upload-filename');
    if (!display.length) {
      display = $('<span class="file-upload-filename"></span>');
      label.append(display);
    }
    display.text(filename || '');
  });
}

export default ProposalBuilderWidget
